/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import ajax from 'helpers/ajax'
import {consoleLog} from 'utils/utility'
import {ThunkAction} from 'model/store/thunk'
import {clearReservations, clearTableState, setReservation, setReservations, setTableState,} from 'store/reservations/OnlineReservationsReducer'
import {ReservationsTableRequest} from 'types/requests/ReservationsTableRequest'

export class OnlineReservationsAction {
    static setReservations = setReservations
    static setTableState = setTableState
    static setReservation = setReservation
    static clearReservations = clearReservations
    static clearTableState = clearTableState



    static fetchGetReservationPlan = (reservation_id: number): ThunkAction<Promise<string>> => {
        return async (): Promise<string> => {
            try {
                const response: {
                    plan: string
                } = await ajax.post('/admin/reservation/seller/get_reservation_plan/' + reservation_id, {}, {})
                if (response?.plan) {
                    return Promise.resolve(response.plan)
                } else {
                    return Promise.reject(response)
                }
            } catch (err) {
                consoleLog('fetchGetReservationPlan - reject')
                consoleLog(err)
                return Promise.reject(err)
            }
        }
    }

    static fetchReservationsListForSellerWithPagination = (
        seller_id: number,
        data: ReservationsTableRequest
    ) => {
        return () => {
            return ajax
                .post(
                    '/admin/reservation/seller/pagination',
                    {
                        per_page: data?.per_page,
                        page: data?.page,
                        search: data?.search && data.search,
                        sorting: data?.sorting,
                        seller_id: seller_id,
                    },
                    {}
                )
                .then(
                    (onResolve) => {
                        return Promise.resolve(onResolve.reservations)
                    },
                    (onReject) => {
                        console.log('fetch data error')
                        console.log(onReject)
                        return Promise.reject(onReject)
                    }
                )
                .catch((error) => {
                    if (error.name === 'CanceledError') {
                        console.log('Request aborted:', error.message)
                    } else {
                        console.error(error)
                    }
                    return Promise.reject(error)
                })
        }
    }
}

export default OnlineReservationsAction
